import PropTypes from 'prop-types';

const StringsArrayCellRenderer = ({ value: values }) => {
  if (Array.isArray(values)) {
    return values.join(',');
  }
  return String(values || '');
};


StringsArrayCellRenderer.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
};

export default StringsArrayCellRenderer;
